import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizationLogsComponent } from './authorizationlogs.component';

const routes: Routes = [ { path: '', component: AuthorizationLogsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthorizationLogsRoutingModule { }
